/** @format */
import { css } from 'styled-components';

import { RestrictedFooterProps, RestrictedFooterVariant } from './index';

/**
 * Base styles for the RestrictedFooter component
 */
const baseStyles = () => css`
    background: var(--colors-surface-secondary);
    border-top: 0.1rem solid var(--colors-border-light);
    width: 100%;
    margin-top: auto;

    .logos {
        grid-area: footer-logo;
        margin-bottom: var(--layout-spacing-24);
    }

    .restricted-footer-content {
        grid-area: footer-content;
    }
    .restricted-footer-trustpilot-container {
        grid-area: footer-trustpilot-container;
        margin-bottom: var(--layout-spacing-24);
    }

    .trusted-shops-container {
        grid-area: footer-trusted-shops-container;
    }

    .trusted-shops-badge {
        margin: 0;
    }

    .credit-message {
        margin-bottom: var(--layout-spacing-24);
    }

    .copyright-notice {
        grid-area: footer-copyright-notice;
    }
`;

const variantStyles = ({ variant }: Partial<RestrictedFooterProps>) => {
    switch (variant) {
        case RestrictedFooterVariant.MOBILE:
            return css`
                .content-wrapper {
                    display: grid;
                    padding: var(--layout-spacing-24);
                    text-align: center;
                    justify-items: center;
                    align-items: center;
                    grid-template-columns: 1fr;
                    grid-template-areas:
                        'footer-logo'
                        'footer-content'
                        'footer-trusted-shops-container'
                        'footer-trustpilot-container'
                        'footer-copyright-notice';

                    .links {
                        margin-bottom: 3.6rem;
                        ul {
                            display: flex;
                            justify-content: center;
                            li {
                                margin: 0 var(--layout-spacing-12);
                                &:last-child:after {
                                    content: unset;
                                }
                            }
                        }
                    }

                    .trusted-shops-badge {
                        margin-bottom: var(--layout-spacing-48);
                    }
                }
            `;
        case RestrictedFooterVariant.DESKTOP:
        default:
            return css`
                .content-wrapper {
                    display: grid;
                    padding-top: var(--layout-spacing-48);
                    padding-bottom: var(--layout-spacing-24);
                    grid-template-columns: 19rem 1fr;
                    grid-template-areas:
                        'footer-logo footer-content'
                        'footer-trusted-shops-container footer-trusted-shops-container'
                        'footer-trustpilot-container footer-trustpilot-container'
                        'footer-copyright-notice footer-copyright-notice';
                    grid-column-gap: var(--layout-spacing-24);

                    .logos {
                        margin-bottom: var(--layout-spacing-16);
                    }

                    .links {
                        margin-bottom: var(--layout-spacing-24);
                        li {
                            margin-right: var(--layout-spacing-24);
                        }
                    }

                    .copyright-notice {
                        grid-column: 2;
                    }
                }
            `;
    }
};

/**
 * The Footer component styles
 *
 * @param {RestrictedFooterProps} props The footer properties object
 */
export const styles = (props: Partial<RestrictedFooterProps>) => css`
    ${baseStyles()}
    ${variantStyles(props)}
`;
